import { Store } from '../core/store';
export var store = new Store();
export var resetReState = function resetReState() {
  return store.reset();
};
export var setReStateInitialValue = function setReStateInitialValue(key, value) {
  return store.setInitialValue(key, value);
};